import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { ArrowBack, InsertDriveFile, Close } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppContainer from "src/components/AppContainer";
import css from "./adminDetail.module.scss";
import PreviewFile from "src/components/PreviewFile";
import { useStore } from "src/providers/store";
import { IFile, IVehicle } from "src/models/vehicle";
import storageApi from "src/api/storageApi";

const AdminDetailPage = () => {
  const { vehicle } = useStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const _id = location.state.toString();

  useEffect(() => {
    getVehicleById();
  }, []);

  const getVehicleById = async () => {
    setLoading(true);
    await vehicle.getVehicleById(_id);
    await setVehicleDetail(vehicle.getVehicleDetail());
    setLoading(false);
  };

  const [isLoading, setLoading] = useState(false);
  const [vehicleDetail, setVehicleDetail] = useState<IVehicle>({
    _id: undefined,
    status: "active",
    approveStatus: "pending",
    travelType: "arrival",
    vehicleType: "",
    licensePlate: "",
    country: "",
    province: "",
    travelByOwner: true,
    carBook: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfCarOwner: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfOwnerIDcard: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfOwnerPassport: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfTax: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM2: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM3: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM4: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM5: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfPowerOfAttorney: {
      url: "",
      isPassed: false,
      remark: "",
    },
    originalPowerOfAttorney: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfIDcardGrantee: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyofCompany: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyofCompanyIDcardGrantor: {
      url: "",
      isPassed: false,
      remark: "",
    },
    phoneNumber: "",
    facebookID: "",
    lineID: "",
    email: "",
    token: "",
    remark: "",
    barcode: "",
    created: {
      date: undefined,
    },
  });

  const [openPreviewFile, setOpenPreviewFile] = useState(false);
  const [snackbar, setSnackbar] = useState({
    severity: "success",
    message: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [FileName, setFileName] = useState("");
  const [filePath, setFilePath] = useState("");

  const statuses = [
    { value: "pending" },
    // { value: "reviewing" },
    { value: "approved" },
    { value: "rejected" },
    // { value: "requestMoreInfo" },
    // { value: "resubmit" },
  ];

  const onValueChange =
    (prop: keyof IVehicle) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setVehicleDetail({ ...vehicleDetail, [prop]: event.target.value });
    };

  const onIsPassedChange =
    (key, obj) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setVehicleDetail({
        ...vehicleDetail,
        [key]: { ...obj, isPassed: event.target.value === "true" },
      });
    };

  const onRemarkChange =
    (key, obj) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setVehicleDetail({
        ...vehicleDetail,
        [key]: { ...obj, remark: event.target.value },
      });
    };

  const onBackClicked = () => {
    navigate(-1);
  };

  const onClickOpenFile = async (key, imagePath) => {
    if (!imagePath) {
      return;
    }

    const response = await storageApi.getReadUrl(imagePath);
    console.log("response", response);
    if (response?.url) {
      setFileName(t(key));
      setFilePath(response.url);
      setOpenPreviewFile(true);
    }
  };

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const isValid = () => {
    // if (vehicleDetail.carBook) {
    //   if (!vehicleDetail.carBook.isPassed) return false;
    //   if (!vehicleDetail.copyOfCarOwner.isPassed) return false;
    //   if (!vehicleDetail.copyOfOwnerIDcard.isPassed) return false;
    //   if (!vehicleDetail.copyOfTax.isPassed) return false;
    //   if (!vehicleDetail.TM2.isPassed) return false;
    //   if (!vehicleDetail.TM3.isPassed) return false;
    //   if (!vehicleDetail.TM4.isPassed) return false;

    //   if (!vehicleDetail.travelByOwner) {
    //     if (!vehicleDetail.copyOfPowerOfAttorney.isPassed) return false;
    //     if (!vehicleDetail.originalPowerOfAttorney.isPassed) return false;
    //     if (!vehicleDetail.copyOfIDcardGrantee.isPassed) return false;
    //   }

    //   return true;
    // }

    if (vehicleDetail.approveStatus === "approved" && !vehicleDetail.barcode) {
      return false;
    }
    return true;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (isValid()) {
      const response = await vehicle.updateVehicle(
        vehicleDetail._id ?? _id,
        vehicleDetail,
      );
      if (response) {
        alert(t("saveSuccess"));
        navigate(-1);
        // setSnackbar({ severity: "success", message: "บันทึกข้อมูลสำเร็จ" });
        // setOpenSnackbar(true);
        // setTimeout(() => {
        //   navigate(-1);
        // }, 2000);
      } else {
        setSnackbar({ severity: "error", message: "บันทึกข้อมูลไม่สำเร็จ" });
        setOpenSnackbar(true);
      }
    }
  };

  const dateDisplay = (date: Date) => {
    date.setHours(date.getHours() + 7);
    const d = date.toISOString().slice(0, 10).split("-").reverse().join("/");
    const t = date.toISOString().slice(11, 19);
    return `${d} ${t}`;
  };

  const tableRow = (key, obj: IFile) => {
    return (
      <TableRow>
        <TableCell component="th" scope="row">
          {t(key)}
        </TableCell>
        <TableCell align="center">
          <Button
            startIcon={<InsertDriveFile />}
            disabled={!obj.url}
            onClick={() => onClickOpenFile(key, obj.url)}
          >
            <u>{t("adminDetailPage.previewFile")}</u>
          </Button>
        </TableCell>
        <TableCell align="center">
          <RadioGroup
            row
            value={obj.isPassed}
            className={css.radioGroup}
            onChange={onIsPassedChange(key, obj)}
          >
            <FormControlLabel
              value={true}
              control={<Radio color="success" />}
              label={t<string>("adminDetailPage.pass")}
            />
            <FormControlLabel
              value={false}
              control={<Radio color="error" />}
              label={t<string>("adminDetailPage.fail")}
            />
          </RadioGroup>
        </TableCell>
        <TableCell>
          <TextField
            value={obj.remark || ""}
            variant="outlined"
            size="small"
            placeholder={t("adminDetailPage.remark")}
            fullWidth
            onChange={onRemarkChange(key, obj)}
          />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <AppContainer
      showAppBar
      showUser
      isLoading={isLoading}
      title={t("adminListPage.title")}
      className={css.appContainer}
    >
      <Container className={css.container}>
        <Box className={css.navBar}>
          <span onClick={onBackClicked} className={css.action}>
            <ArrowBack className={css.icon} /> {t("adminDetailPage.back")}
          </span>
        </Box>
        <Card sx={{ minWidth: 275 }} className={css.card}>
          <CardHeader title={t("adminDetailPage.detailInfo")}></CardHeader>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("travelType")}</span>
                  <span className={css.text}>
                    {t(vehicleDetail.travelType)}
                  </span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("adminDetailPage.date")}</span>
                  <span className={css.text}>
                    {vehicleDetail.created?.date
                      ? dateDisplay(new Date(vehicleDetail.created?.date))
                      : "-"}
                  </span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("travelByOwner")}</span>
                  {vehicleDetail.travelByOwner === true ? (
                    <span className={css.text}>{t("yes")}</span>
                  ) : (
                    <span className={css.text}>{t("no")}</span>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} className={css.topic}>
                {t("vehicleInfo")}
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("vehicleType")}</span>
                  <span className={css.text}>
                    {t("constant.vehicleType." + vehicleDetail.vehicleType)}
                  </span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("registration")}</span>
                  <span className={css.text}>{vehicleDetail.licensePlate}</span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("province")}</span>
                  <span className={css.text}>{vehicleDetail.province}</span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("country")}</span>
                  <span className={css.text}>{vehicleDetail.country}</span>
                </Box>
              </Grid>
              <Grid item xs={12} className={css.topic}>
                {t("contactInfo")}
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("phoneNumber")}</span>
                  <span className={css.text}>{vehicleDetail.phoneNumber}</span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("email")}</span>
                  <span className={css.text}>{vehicleDetail.email}</span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("facebookID")}</span>
                  <span className={css.text}>
                    {vehicleDetail.facebookID || "-"}
                  </span>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className={css.dataLine}>
                  <span className={css.label}>{t("lineID")}</span>
                  <span className={css.text}>
                    {vehicleDetail.lineID || "-"}
                  </span>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 275 }} className={css.card}>
          <CardHeader
            title={t("adminDetailPage.attachedFileInfo")}
          ></CardHeader>
          <CardContent>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="medium">
                <TableHead className={css.tableHeader}>
                  <TableRow>
                    <TableCell>{t("adminDetailPage.attachedFile")}</TableCell>
                    <TableCell align="center">{t("attachedFile")}</TableCell>
                    <TableCell align="center">
                      {t("adminDetailPage.result")}
                    </TableCell>
                    <TableCell align="center">
                      {t("adminDetailPage.remark")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRow("carBook", vehicleDetail.carBook)}
                </TableBody>
                <TableBody>
                  {tableRow("copyOfCarOwner", vehicleDetail.copyOfCarOwner)}
                </TableBody>
                <TableBody>
                  {tableRow(
                    "copyOfOwnerIDcard",
                    vehicleDetail.copyOfOwnerIDcard,
                  )}
                </TableBody>
                <TableBody>
                  {tableRow(
                    "copyOfOwnerPassport",
                    vehicleDetail.copyOfOwnerPassport,
                  )}
                </TableBody>
                <TableBody>
                  {tableRow("copyOfTax", vehicleDetail.copyOfTax)}
                </TableBody>
                <TableBody>{tableRow("TM2", vehicleDetail.TM2)}</TableBody>
                <TableBody>{tableRow("TM3", vehicleDetail.TM3)}</TableBody>
                <TableBody>{tableRow("TM4", vehicleDetail.TM4)}</TableBody>
                {/* <TableBody>{tableRow("TM5", t("TM5"))}</TableBody> */}
                {/* {!vehicleDetail.travelByOwner && (
                  <TableBody>
                    {tableRow(
                      "copyOfPowerOfAttorney",
                      vehicleDetail.copyOfPowerOfAttorney
                    )}
                  </TableBody>
                )} */}
                {!vehicleDetail.travelByOwner && (
                  <TableBody>
                    {tableRow(
                      "originalPowerOfAttorney",
                      vehicleDetail.originalPowerOfAttorney,
                    )}
                  </TableBody>
                )}
                {!vehicleDetail.travelByOwner && (
                  <TableBody>
                    {tableRow(
                      "copyOfIDcardGrantee",
                      vehicleDetail.copyOfIDcardGrantee,
                    )}
                  </TableBody>
                )}
                {!vehicleDetail.travelByOwner && (
                  <TableBody>
                    {tableRow("copyofCompany", vehicleDetail.copyofCompany)}
                  </TableBody>
                )}
                {!vehicleDetail.travelByOwner && (
                  <TableBody>
                    {tableRow(
                      "copyofCompanyIDcardGrantor",
                      vehicleDetail.copyofCompanyIDcardGrantor,
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </CardContent>
        </Card>

        <Card sx={{ minWidth: 275 }} className={css.card}>
          <CardHeader title={t("adminDetailPage.resultInfo")}></CardHeader>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>{t("adminListPage.status")}</InputLabel>
                  <Select
                    id="status"
                    value={vehicleDetail.approveStatus || ""}
                    label={t("adminListPage.status")}
                    onChange={onValueChange("approveStatus")}
                  >
                    {statuses.map((status, index) => (
                      <MenuItem key={index} value={status.value}>
                        {t("constant.status." + status.value)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {vehicleDetail.approveStatus === "approved" && (
                <Grid item xs={12} md={6}>
                  <TextField
                    id="barcode"
                    label={t("adminDetailPage.barcode")}
                    variant="outlined"
                    placeholder={t("adminDetailPage.barcodePlaceHolder")}
                    fullWidth
                    required
                    value={vehicleDetail.barcode}
                    onChange={onValueChange("barcode")}
                  />
                </Grid>
              )}
            </Grid>
          </CardContent>
          <CardActions className={css.cardAction}>
            <Button
              variant="outlined"
              color="error"
              size="large"
              startIcon={<Close />}
              onClick={onBackClicked}
            >
              {t("adminDetailPage.btnBack")}
            </Button>
            <Button
              variant="contained"
              size="large"
              startIcon={<SendIcon />}
              disabled={!isValid()}
              onClick={onSubmit}
            >
              {t("adminDetailPage.btnSubmit")}
            </Button>
          </CardActions>
        </Card>

        <PreviewFile
          title={FileName}
          open={openPreviewFile || false}
          onCloseClicked={() => setOpenPreviewFile(false)}
          imagePath={filePath}
        ></PreviewFile>

        <Snackbar
          open={openSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            variant="filled"
            severity={snackbar.severity === "success" ? "success" : "error"}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </AppContainer>
  );
};
export default observer(AdminDetailPage);
